function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "slant_header");

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "0.044 0 0.044 62 0.044 62 1400.044 0 0.044 0",
  fill: "#fff"
});

function SvgSlantHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1400.0884 63.999",
    preserveAspectRatio: "none meet"
  }, props), _ref, _ref2, /*#__PURE__*/React.createElement("line", {
    x1: 0.0442,
    y1: 63,
    x2: 1400.0442,
    y2: 1,
    style: {
      fill: "none",
      stroke: "#979797",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }));
}

export default __webpack_public_path__ + "media/schedule/images/slant_header-a221c3f49ec189db7d5fbfff569b76d9.svg";
export { SvgSlantHeader as ReactComponent };